import { CallToActionInputs } from './CallToAction';

export const callToActionTransformer = (node: any): CallToActionInputs => {
    return {
        color: `blue`,
        title: node.field_component_title,
        content: node.field_text_content?.value,
        url: node.field_cta_link ? node.field_cta_link[0]?.uri : undefined,
        buttonText: node.field_cta_link ? node.field_cta_link[0]?.title : ``,
    };
};
